<template>
    <div class="custom-bg-928AFD">
        <div class="container custom-bg-928AFD">
            <transition name="fade" mode="out-in">
                <div v-if="step === 0" class="splash-screen">
                    <div class="logo-container">
                        <img src="@/assets/img/new/splash2.jpg" class="logo" />
                    </div>
                </div>
                <div v-else class="onboarding">
                    <div class="onboarding-content">
                        <img :src="currentScreen.image" class="onboarding-image p-3" />
                        <div class="card-fix">
                            <h2>{{ currentScreen.title }}</h2>
                            <p>{{ currentScreen.description }}</p>
                            <div class="pagination mb-2">
                                <span v-for="(screen, index) in screens" :key="index" :class="{ active: index + 1 === step }" @click="goToStep(index + 1)">
      </span>
                            </div>
                            <button @click="nextStep" class="btn">
                        {{ step === screens.length ? "Get Started" : "Continue" }}
                    </button>
                        </div>
                    </div>
    
                </div>
            </transition>
        </div>
    </div>
</template>
  
<script>
export default {
    data() {
        return {
            step: 0, // 0 = splash screen, 1+ = onboarding screens
            screens: [{
                    image: require("@/assets/img/new/onboarding5.png"),
                    title: "Unlock Exclusive Marketing Insights",
                    description: "Get AI-powered reviews for your marketing videos and receive valuable insights.",
                },
                {
                    image: require("@/assets/img/new/onboarding6.png"),
                    title: "AI-Powered Video Reviews in One Tap",
                    description: "Connect with expert feedback, analyze your video content, and refine your strategy.",
                },
                {
                    image: require("@/assets/img/new/onboarding7.png"),
                    title: "Earn Rewards for Your Feedback",
                    description: "Complete surveys and get free e-vouchers as a token of appreciation.",
                },
            ],
        };
    },
    computed: {
        currentScreen() {
            return this.screens[this.step - 1];
        },
    },
    mounted() {
        // setTimeout(() => {
        //     this.step = 1; // Move from splash screen to onboarding
        // }, 3000);
        if (window.innerWidth > 1024) {
            this.$router.push("/login"); // Redirect to login if screen is wider than 1024px
        } else {
            setTimeout(() => {
                this.step = 1; // Move from splash screen to onboarding
            }, 3000);
        }
    },
    methods: {
        nextStep() {
            if (this.step < this.screens.length) {
                this.step++;
            } else {
                this.$router.push("/login"); // Navigate to home page after onboarding
            }
        },
        goToStep(stepNumber) {
            this.step = stepNumber; // Directly change the step when clicking a dot
        }
    },
};
</script>
  
<style scoped>
/* General Container */

.container {
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #928AFD;
}

/* Splash Screen */

.splash-screen {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100vw;
    height: 100vh;
    overflow: hidden;
    /* Prevent scrolling */
}

.logo-container {
    text-align: center;
}

.logo {
    width: 250px;
    animation: fadeIn 2s ease-in-out;
}

/* Onboarding */

.onboarding {
    text-align: center;
    width: 100%;
    max-width: 400px;
}

.onboarding-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    /* Centers content vertically */
    height: 100vh;
    width: 100%;
    padding-bottom: 150px;
    /* Add space for card */
}

.onboarding-image {
    max-width: 100%;
    height: auto;
    flex-grow: 1;
    /* Allows the image to take available space */
    object-fit: contain;
    /* Ensures it fits without overflow */
}

h2 {
    font-size: 22px;
    color: #333;
}

p {
    font-size: 14px;
    color: #666;
}

.btn {
    width: 100%;
    padding: 10px;
    background: #6a5acd;
    color: white;
    border: none;
    border-radius: 25px;
    font-size: 16px;
    cursor: pointer;
}

.btn:hover {
    background: #5b4bcf;
}

/* Pagination */

.pagination {
    display: flex;
    justify-content: center;
    margin-top: 15px;
}

.pagination span {
    width: 8px;
    height: 8px;
    margin: 5px;
    background: #ddd;
    border-radius: 50%;
    display: inline-block;
    cursor: pointer;
    /* Makes dots clickable */
    transition: background 0.3s ease;
}

.pagination .active {
    background: #6a5acd;
}

/* Animations */

.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to {
    opacity: 0;
}

@keyframes fadeIn {
    0% {
        opacity: 0;
        transform: scale(0.9);
    }
    100% {
        opacity: 1;
        transform: scale(1);
    }
}

.card-fix {
    width: 90%;
    max-width: 380px;
    background: white;
    padding: 20px;
    box-shadow: 0px -5px 20px rgba(0, 0, 0, 0.1);
    position: absolute;
    bottom: 40px;
    left: 50%;
    transform: translateX(-50%);
    border-radius: 20px;
    min-height: 220px; /* Increase this to match the tallest card */
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}
</style>